import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Template_2.css";

const Template_2_AdvertisementPackages = ({ onEnquireClick }) => {
  const [ads, setAds] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  // Static advertisement data with updated Pexels image URLs for Maldives and Africa
  useEffect(() => {
    setIsLoading(true);
    const mockAds = [
      {
        packageId: "ad-1",
        destinationName: "Maldives",
        packagesCount: 12,
        imageSrc:
          "https://images.pexels.com/photos/3250613/pexels-photo-3250613.jpeg?auto=compress&cs=tinysrgb&w=1470&h=600&fit=crop",
        fallbackImage: "https://via.placeholder.com/1470x600?text=Maldives",
        isFeatured: true,
        description:
          "Dive into paradise with overwater villas and turquoise waters!",
        highlightColor: "#FF6B6B",
      },
      {
        packageId: "ad-2",
        destinationName: "Himalayas",
        packagesCount: 8,
        imageSrc:
          "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80",
        fallbackImage: "https://via.placeholder.com/1470x280?text=Himalayas",
        isFeatured: false,
        description: "Trek through majestic peaks and serene valleys.",
        highlightColor: "#4ECDC4",
      },
      {
        packageId: "ad-3",
        destinationName: "Paris",
        packagesCount: 10,
        imageSrc:
          "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?ixlib=rb-4.0.3&auto=format&fit=crop&w=1473&q=80",
        fallbackImage: "https://via.placeholder.com/1470x280?text=Paris",
        isFeatured: false,
        description:
          "Romance awaits with Eiffel Tower views and Seine cruises.",
        highlightColor: "#FFD166",
      },
      {
        packageId: "ad-4",
        destinationName: "Africa",
        packagesCount: 6,
        imageSrc:
          "https://images.pexels.com/photos/259863/pexels-photo-259863.jpeg?auto=compress&cs=tinysrgb&w=1471&h=280&fit=crop",
        fallbackImage: "https://via.placeholder.com/1470x280?text=Africa",
        isFeatured: false,
        description: "Experience the Big Five on a thrilling safari adventure.",
        highlightColor: "#6A0572",
      },
      {
        packageId: "ad-5",
        destinationName: "Santorini",
        packagesCount: 9,
        imageSrc:
          "https://images.unsplash.com/photo-1596422846543-75c6fc197f07?ixlib=rb-4.0.3&auto=format&fit=crop&w=1464&q=80",
        fallbackImage: "https://via.placeholder.com/1470x280?text=Santorini",
        isFeatured: false,
        description: "Sunsets and whitewashed villas in a Greek paradise.",
        highlightColor: "#3A86FF",
      },
    ];
    setAds(mockAds);
    setIsLoading(false);
  }, []);

  // Handle image loading errors by setting fallback image and logging error
  const handleImageError = (e, fallback, destinationName) => {
    console.error(
      `Failed to load image for ${destinationName}: ${e.target.src}`
    );
    e.target.src = fallback;
  };

  return (
    <section className="Template_2 section Template_2 advertisement-packages">
      <div className="Template_2 container">
        <div className="Template_2 section-title">
          <h2>Explore Top Destinations</h2>
          <p>
            Discover our exclusive destinations with curated travel packages!
          </p>
        </div>

        {isLoading ? (
          <div className="Template_2 loading">Loading destinations...</div>
        ) : ads.length === 0 ? (
          <div className="Template_2 no-data">No destinations available</div>
        ) : (
          <div className="Template_2 ads-container">
            <div className="Template_2 ads-left">
              <div className="Template_2 ads-top">
                {ads
                  .filter((ad) => !ad.isFeatured)
                  .slice(0, 2)
                  .map((ad) => (
                    <div
                      key={ad.packageId}
                      className="Template_2 ad-item"
                      style={{ "--highlight-color": ad.highlightColor }}
                    >
                      <div className="Template_2 ad-image-container">
                        <img
                          src={ad.imageSrc}
                          alt={ad.destinationName}
                          onError={(e) =>
                            handleImageError(
                              e,
                              ad.fallbackImage,
                              ad.destinationName
                            )
                          }
                        />
                        <div className="Template_2 ad-overlay">
                          <h4>{ad.destinationName}</h4>
                          <p className="Template_2 ad-description">
                            {ad.description}
                          </p>
                          <div className="Template_2 ad-meta">
                            <span>{ad.packagesCount} Packages</span>
                          </div>
                          <button
                            className="Template_2 ad-explore-btn"
                            onClick={() =>
                              navigate(
                                `/template_2_packagedetails/${ad.packageId}`
                              )
                            }
                          >
                            Explore Now
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
              <div className="Template_2 ads-bottom">
                {ads
                  .filter((ad) => !ad.isFeatured)
                  .slice(2, 4)
                  .map((ad) => (
                    <div
                      key={ad.packageId}
                      className="Template_2 ad-item"
                      style={{ "--highlight-color": ad.highlightColor }}
                    >
                      <div className="Template_2 ad-image-container">
                        <img
                          src={ad.imageSrc}
                          alt={ad.destinationName}
                          onError={(e) =>
                            handleImageError(
                              e,
                              ad.fallbackImage,
                              ad.destinationName
                            )
                          }
                        />
                        <div className="Template_2 ad-overlay">
                          <h4>{ad.destinationName}</h4>
                          <p className="Template_2 ad-description">
                            {ad.description}
                          </p>
                          <div className="Template_2 ad-meta">
                            <span>{ad.packagesCount} Packages</span>
                          </div>
                          <button
                            className="Template_2 ad-explore-btn"
                            onClick={() =>
                              navigate(
                                `/template_2_packagedetails/${ad.packageId}`
                              )
                            }
                          >
                            Explore Now
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
            <div className="Template_2 ads-right">
              {ads
                .filter((ad) => ad.isFeatured)
                .map((ad) => (
                  <div
                    key={ad.packageId}
                    className="Template_2 ad-featured-item"
                    style={{ "--highlight-color": ad.highlightColor }}
                  >
                    <div className="Template_2 ad-image-container">
                      <img
                        src={ad.imageSrc}
                        alt={ad.destinationName}
                        onError={(e) =>
                          handleImageError(
                            e,
                            ad.fallbackImage,
                            ad.destinationName
                          )
                        }
                      />
                      <div className="Template_2 ad-overlay">
                        <h3>{ad.destinationName}</h3>
                        <p className="Template_2 ad-description">
                          {ad.description}
                        </p>
                        <div className="Template_2 ad-meta">
                          <span>{ad.packagesCount} Packages Available</span>
                        </div>
                        <button
                          className="Template_2 ad-explore-btn"
                          onClick={() =>
                            navigate(
                              `/template_2_packagedetails/${ad.packageId}`
                            )
                          }
                        >
                          Explore Now
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Template_2_AdvertisementPackages;
